import request from '@/utils/request'

// 查询入库明细报表
export function apiGetInventoryDetailsList (query) {
  return request({
    url: '/inv/invOnhandQuantities/wmsStorageDetailList',
    method: 'get',
    params: query
  })
}

// 入库明细报表导出
export function apiInvOnhandQuantitiesExport (data) {
  return request({
    url: '/inv/invOnhandQuantities/v2/wmsStorageDetailExport',
    method: 'post',
    data: data
  })
}

// 查询出库明细账列表（成品仓）
export function apiWmsOutboundDetailListw3 (query) {
  return request({
    url: '/inv/invOnhandQuantities/wmsOutboundDetailListw3',
    method: 'get',
    params: query
  })
}

// 查询入库明细账列表（成品仓）
export function apiWmsStorageDetailListw3 (query) {
  return request({
    url: '/inv/invOnhandQuantities/wmsStorageDetailListw3',
    method: 'get',
    params: query
  })
}

// 查询出库明细报表
export function apiGetInventoryOutboundDetailsList (query) {
  return request({
    url: '/inv/invOnhandQuantities/wmsOutboundDetailList',
    method: 'get',
    params: query
  })
}

// 导出出库明细报表
export function apiInvOnhandQuantitiesOutboundExport (data) {
  return request({
    url: '/inv/invOnhandQuantities/v2/wmsOutboundDetailExport',
    method: 'post',
    data: data
  })
}

// 查询零部件叫料报表
export function apiGetComponentCallList (data) {
  return request({
    url: '/inv/invCallRequestLines/getComponentCallList',
    method: 'post',
    data: data
  })
}

// 导出零部件叫料报表
export function apiInvExportComponentCallList (data) {
  return request({
    url: '/inv/invCallRequestLines/exportComponentCallList',
    method: 'post',
    data: data
  })
}

// 导出出库明细账列表
export function apiWmsOutboundDetailExport (data) {
  return request({
    url: '/inv/invOnhandQuantities/v2/wmsOutboundDetailExport?warehouse=3',
    method: 'post',
    data: data
  })
}

// 导出入库明细账列表
export function apiWmsStorageDetailExport (data) {
  return request({
    url: '/inv/invOnhandQuantities/v2/wmsStorageDetailExport?warehouse=3',
    method: 'post',
    data: data
  })
}
